import React, { Component } from "react";
import uuid from "uuid";
import PropTypes from "prop-types";
import styled from "styled-components";

const Container = styled.div``;

const Pager = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  margin: 0;
  font-size: 11px;
`;

const Page = styled.li`
  background-color: ${props => props.theme.assetList.pagination.background}
  list-style-type: none;

  transition: background-color 280ms ease;

  &.current {
    color: ${props => props.theme.assetList.pagination.active};
    text-decoration: underline;
  }

  & > button,
  > span {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    padding-top: 1px;
    text-decoration: none;
    border: ${props => `1px solid ${props.theme.assetList.pagination.border}`};
    border-left-width: 0;
    min-width: 20px;
    min-height: 20px;


    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  &:not([class*='current']) button:hover {
    background-color: ${props => props.theme.assetList.pagination.hover};
  }

  &:first-of-type button {
    border-left-width: 1px;
  }
`;

const id = uuid.v4();
const Mousetrap = window.Mousetrap;

class Pagination extends Component {
  componentDidMount() {
    const { nextPageShortcut, prevPageShortcut } = this.props;
    if (nextPageShortcut) {
      Mousetrap.bindGlobal(nextPageShortcut, () =>
        this.changePage(this.props.currentPage + 1)
      );
    }
    if (prevPageShortcut) {
      Mousetrap.bindGlobal(prevPageShortcut, () =>
        this.changePage(this.props.currentPage - 1)
      );
    }
  }

  componentWillUnmount() {
    const { nextPageShortcut, prevPageShortcut } = this.props;
    if (nextPageShortcut) {
      Mousetrap.unbind(nextPageShortcut);
    }
    if (prevPageShortcut) {
      Mousetrap.unbind(prevPageShortcut);
    }
  }

  getPageList = () => {
    const {
      currentPage,
      totalPages,
      buffer,
      prev,
      next,
      first,
      last
    } = this.props;
    const pageList = [];
    const minPage = Math.max(1, currentPage - buffer);
    const maxPage = Math.min(totalPages, currentPage + buffer);

    if (prev) {
      pageList.push(
        <Page key="prev">
          <button
            disabled={currentPage === 1}
            onClick={() => this.changePage(currentPage - 1)}
          >
            &laquo;
          </button>
        </Page>
      );
    }

    if (first && minPage > 1) {
      pageList.push(
        <Page
          key={`page-1-${id}`}
          className={currentPage === 1 ? "current" : ""}
        >
          <button
            disabled={currentPage === 1}
            onClick={() => this.changePage(1)}
          >
            1
          </button>
        </Page>
      );
      if (minPage > 2) {
        pageList.push(
          <Page key={`page-first-ellip-${id}`}>
            <span>&hellip;</span>
          </Page>
        );
      }
    }

    for (let i = 0; i <= Math.max(maxPage - minPage, 0); i++) {
      pageList.push(
        <Page
          key={`page-${minPage + i}-${id}`}
          className={currentPage === minPage + i ? "current" : ""}
        >
          <button
            disabled={currentPage === minPage + i}
            onClick={() => this.changePage(minPage + i)}
          >
            {minPage + i}
          </button>
        </Page>
      );
    }

    if (last) {
      if (maxPage + 1 < totalPages) {
        pageList.push(
          <Page key={`page-last-ellip-${id}`}>
            <span>&hellip;</span>
          </Page>
        );
      }
      if (maxPage < totalPages) {
        pageList.push(
          <Page
            key={`page-${totalPages}-${id}`}
            className={currentPage === totalPages ? "current" : ""}
          >
            <button
              disabled={currentPage === totalPages}
              onClick={() => this.changePage(totalPages)}
            >
              {totalPages}
            </button>
          </Page>
        );
      }
    }

    if (next) {
      pageList.push(
        <Page key="next">
          <button
            disabled={currentPage === totalPages}
            onClick={() => this.changePage(currentPage + 1)}
          >
            &raquo;
          </button>
        </Page>
      );
    }

    return pageList;
  };

  changePage = newPage => {
    console.log(`changing page to ${newPage}`);
    if (newPage > this.props.totalPages || newPage < 1) {
      return;
    }
    this.props.onChange(newPage);
  };

  render() {
    return (
      <Container>
        <Pager>{this.getPageList()}</Pager>
      </Container>
    );
  }
}

Pagination.defaultProps = {
  prev: true,
  next: true,
  first: true,
  last: true,
  buffer: 3,
  nextPageShortcut: null,
  prevPageShortcut: null
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  buffer: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  prev: PropTypes.bool,
  next: PropTypes.bool,
  first: PropTypes.bool,
  last: PropTypes.bool,
  nextPageShortcut: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  prevPageShortcut: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
};

export default Pagination;



// WEBPACK FOOTER //
// ./app/components/Pagination.js